const addSuffix = function (url, size) {
  size = '_' + Math.floor(size) + 'x' // shopify image size filter format
  url = url.replace(/^(.+)\.([^.]+)$/, '$1' + size + '.$2') // add suffix to filename
  return url
}

module.exports = addSuffix



// WEBPACK FOOTER //
// ./src/assets/js/resizeShopifyImgUrl.js